import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { withTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { SectionWrap, Logo, Text } from 'core/ui/atoms';
import SignInForm from 'core/ui/components/SignInForm';
import GetAppButton from 'core/ui/components/GetAppButton';
import { loginWithToken } from 'core/api/actions';
// import NY from 'core/ui/components/NY';

// import BLACK_FRIDAY_IMAGE from '../../assets/images/black_friday.png';

const SignIn = ({ t }) => {
  const currentLocation = useLocation();

  useEffect(() => {
    const forceSign = async () => {
      const params = new URLSearchParams(currentLocation.search);
      const authToken = params.get('authToken');
      if (authToken) {
        await loginWithToken(authToken);
      }
    };
    forceSign();
  }, [currentLocation.search]);

  return (
    <ContentContainer>
      <Logo />
      <SectionWrap>
        <SignInForm />
      </SectionWrap>
      <BottomContainer>
        <PolicyText>{t('main.authorizationText')}</PolicyText>
        <PolicyLink href='https://help.cielomeditation.ru' target='_blank'>{t('main.authorizationText2')}</PolicyLink>
      </BottomContainer>
      <Cont>
        <PolicyText>{t('main.noAccountMessage')}</PolicyText>
      </Cont>
      <Cont isBottom>
        <GetAppButton isApple />
        <GetAppButton />
      </Cont>
      {/* <BlackFriday href={'https://help.cielomeditation.ru/#!/tab/465761256-4'} target={'__blank'}>
        <BlackFridayImage src={BLACK_FRIDAY_IMAGE} />
      </BlackFriday> */}
      {/* <NY /> */}
    </ContentContainer>
  );
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  padding-bottom: 24px;
`;

const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  align-items: center;
`;

const PolicyText = styled(Text)`
  color: ${p => p.theme.colors.grays.light};
  margin-bottom: 0;
`;

const PolicyLink = styled.a`
  color: ${p => p.theme.colors.white};
  text-decoration: none;
  ${p => p.theme.max('sm')`
    white-space: break-spaces;
    text-align: center;
	`}
`;

const Cont = styled.div`
  display: flex;
  justify-content: center;
  ${p => p.isBottom && css`
    padding-top: 12px;
  `}
  a {
    text-decoration: none;
  }
`;

// const BlackFriday = styled.a`
//   position: fixed;
//   top: 0;
//   left: 0;
//   cursor: pointer;
// `;

// const BlackFridayImage = styled.img`
//   width: 200px;
//   height: 200px;
//   z-index: 9999;
//   position: relative;
// `;

export default withTranslation()(SignIn);
